import moment from "moment";
import { WeeklyMeetingDays } from "../../../enums/WeeklyMeetingDaysEnum";
import { RecurrenceTypeEnum } from "../../../enums/RecurrenceTypeEnum";
import { formatDate } from "./value-modifier";

export const occurenceText = (start: Date, end: Date, recurrenceType: RecurrenceTypeEnum, daysOfWeek: string) => {
    const startDate = formatDate(start, "MM/DD/YYYY");
    const endDate = formatDate(end, "MM/DD/YYYY");
    let textPrefix = "";
    if (recurrenceType === RecurrenceTypeEnum.Daily) {
        textPrefix = "day";
    } else if (recurrenceType === RecurrenceTypeEnum.Weekly) {
        if (daysOfWeek.length) {
            const orderedDays = daysOfWeek
                .split(",")
                .map(Number)
                .sort((a, b) => a - b);
            const days = orderedDays.map((day) => WeeklyMeetingDays.getKeyUsingValue(day));

            if (days.length === 1) {
                textPrefix = days[0];
            } else if (days.length === 2) {
                textPrefix = `${days[0]} and ${days[1]}`;
            } else {
                textPrefix = `${days.slice(0, -1).join(", ")} and ${days[days.length - 1]}`;
            }
        } else return "";
    } else if (recurrenceType === RecurrenceTypeEnum.Monthly) {
        textPrefix = `month on day ${moment(start).date()}`;
    }
    return `Event occurs every ${textPrefix} starting ${startDate} until ${endDate}`;
};
